// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ReliableUPS_TheComp__z7LPZ"};